// src/pages/WhatWeDo.js
import React from "react";
import iopexLogo from "../assets/images/iopex.webp";
import checkIcon from "../assets/icons/fi_14090371.svg"; 

function WhatWeDo() {
  const rows = [
      ["Self-Service Platform", "Not available", "Advertiser campaign UI, automated bidding, real-time reporting", "Built 100+ platforms"],
      ["Revenue Operations", "Manual/Limited", "Ad ops, inventory management, yield optimization, billing", "$6.8B managed"],
      ["Programmatic Integration", "Not integrated", "DSPs (Google, Trade Desk), SSPs, PMPs, open web", "110K+ campaigns"],
      ["Creative Operations", "Advertiser-dependent", "Dynamic creative, personalization, 200K+ assets/year", "3.5M+ trafficked"],
      ["Omnichannel Activation", "Limited channels", "CTV, social, display, video, audio, in-store, wallet", "Full omnichannel"],
      ["Advanced Measurement", "Card-linking works", "Incrementality, MMM, attribution, clean rooms", "Full measurement stack"],
      ["System Integration", "Siloed systems", "CRM, billing, DSPs, analytics, reporting (unified)", "100+ integrations"],
      ["Agentic AI Operations", "Copilot partnership only", "Automated planning, I/O, activation, optimization, billing", "AI-first approach"],
    ];
  
    return (
      <div className="whyus-page">
        {/* 🔹 Top Logo */}
        <header className="whyus-header">
          <img src={iopexLogo} alt="iOPEX Logo" className="whyus-logo" />
        </header>
  
        {/* 🔸 Title */}
        <h1 className="whyus-title">Help Scaling Retail Media Networks</h1>
  
        {/* 🧩 Table */}
        <div className="whyus-table-wrapper">
          <table className="whyus-table">
            <thead>
              <tr>
                <th>Capability</th>
                <th>Probable State</th>
                <th>Required for Scaling</th>
                <th>iOPEX Delivers</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={idx}>
                  {row.map((col, i) => (
                    <td key={i}>
                      {i === 3 ? (
                        <div className="iopex-cell">
                          <img src={checkIcon} alt="✔" className="check-icon" />
                          <span>{col}</span>
                        </div>
                      ) : (
                        col
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

export default WhatWeDo;
